import { useState } from 'react';
import { Table, Button, Space, Tag } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import { PlusOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';

interface RoleData {
  id: string;
  name: string;
  description: string;
  permissions: string[];
  userCount: number;
  createdAt: string;
}

function Roles() {
  const [loading] = useState(false);

  const columns: ColumnsType<RoleData> = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: 80,
    },
    {
      title: '角色名称',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: '描述',
      dataIndex: 'description',
      key: 'description',
    },
    {
      title: '权限',
      dataIndex: 'permissions',
      key: 'permissions',
      render: (permissions: string[]) => (
        <>
          {permissions.map((permission) => (
            <Tag key={permission} color="blue">
              {permission}
            </Tag>
          ))}
        </>
      ),
    },
    {
      title: '用户数',
      dataIndex: 'userCount',
      key: 'userCount',
    },
    {
      title: '创建时间',
      dataIndex: 'createdAt',
      key: 'createdAt',
    },
    {
      title: '操作',
      key: 'action',
      render: () => (
        <Space size="middle">
          <Button type="link" icon={<EditOutlined />}>编辑</Button>
          <Button type="link" danger icon={<DeleteOutlined />}>删除</Button>
        </Space>
      ),
    },
  ];

  const mockData: RoleData[] = [
    {
      id: '1',
      name: '管理员',
      description: '系统管理员，拥有所有权限',
      permissions: ['用户管理', '角色管理', '系统设置'],
      userCount: 5,
      createdAt: '2024-01-01 10:00:00',
    },
    {
      id: '2',
      name: '普通用户',
      description: '普通用户，基础权限',
      permissions: ['查看数据'],
      userCount: 120,
      createdAt: '2024-01-01 10:00:00',
    },
  ];

  return (
    <div>
      <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between' }}>
        <h1>角色权限管理</h1>
        <Button type="primary" icon={<PlusOutlined />}>
          添加角色
        </Button>
      </div>
      <Table
        columns={columns}
        dataSource={mockData}
        rowKey="id"
        loading={loading}
        pagination={{
          total: mockData.length,
          pageSize: 10,
          showSizeChanger: true,
          showTotal: (total) => `共 ${total} 条`,
        }}
      />
    </div>
  );
}

export default Roles;
